import { ToggleButtonGroup as MuiToggleButtonGroup } from '@material-ui/lab'
import * as React from 'react'

const fieldToToggleButtonGroup = ( {
  field: { onChange: _onChange, onBlur: fieldOnBlur, ...field },
  type,
  onChange,
  onBlur,
  form,
  ...props
} ) => ( {
  onBlur: () => fieldOnBlur( field.name ),
  onChange: ( _event, newValue ) => form.setFieldValue( field.name, newValue ),
  ...field,
  ...props,
} )

const ToggleButtonGroup = ( props ) => (
  <MuiToggleButtonGroup {...fieldToToggleButtonGroup( props )} type="checkbox" />
)

export default ToggleButtonGroup
